import { DecimalInput } from './DecimalInput';

export default DecimalInput;
